// import { useState, useEffect, useContext, useCallback, useMemo } from "react";
// import { AuthContext } from "../context/AuthContext";
// import axios from "axios";
// import { API_URL } from "../../Constants";

// // ─── Role helpers (same convention as Dashboard) ────────────────────────────
// const ROLE = {
//   COMPANY: "COMPANY",
//   VICE_PRESIDENT: "VICE_PRESIDENT",
//   MANAGER: "MANAGER",
//   TEAM_LEAD: "TEAM_LEAD",
//   EXECUTIVE: "EXECUTIVE",
//   HR: "HR",
//   SUPER_SUPER_ADMIN: "SUPER_SUPER_ADMIN",
//   SUPER_ADMIN: "SUPER_ADMIN",
//   RESELLER: "RESELLER",
// };
// const isOwnerLevel = (t) =>
//   [ROLE.COMPANY, ROLE.SUPER_SUPER_ADMIN, ROLE.SUPER_ADMIN, ROLE.RESELLER].includes(t);

// // ─── Token helper ────────────────────────────────────────────────────────────
// const authHeader = () => ({
//   Authorization: `Bearer ${localStorage.getItem("token")}`,
// });

// // ─── Small shared UI bits (mirrors Dashboard's visual language) ─────────────
// const Avatar = ({ name = "", color = "#673AB7" }) => {
//   const parts = name.trim().split(" ");
//   const initials = parts.length >= 2
//     ? parts[0][0] + parts[parts.length - 1][0]
//     : (parts[0]?.[0] ?? "?");
//   return (
//     <div className="apt-avatar" style={{ background: color + "22", color }}>
//       {initials.toUpperCase()}
//     </div>
//   );
// };

// const StatusPill = ({ active }) => (
//   <span
//     className="apt-pill"
//     style={{
//       background: active ? "#dcfce7" : "#fee2e2",
//       color: active ? "#16a34a" : "#dc2626",
//     }}
//   >
//     {active ? "Active" : "Inactive"}
//   </span>
// );

// const StatBadge = ({ label, value, icon, accent = "#673AB7" }) => (
//   <div className="apt-stat-card" style={{ "--accent": accent }}>
//     <div className="apt-stat-icon">{icon}</div>
//     <div className="apt-stat-body">
//       <div className="apt-stat-val">{value ?? "—"}</div>
//       <div className="apt-stat-label">{label}</div>
//     </div>
//     <div className="apt-stat-bar" />
//   </div>
// );

// const EmptyState = ({ message = "No data available" }) => (
//   <div className="apt-empty">
//     <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2">
//       <path d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
//     </svg>
//     <p>{message}</p>
//   </div>
// );

// const Skeleton = ({ h = 60 }) => (
//   <div className="apt-skeleton" style={{ height: h }} />
// );

// const ConfirmModal = ({ open, title, message, onCancel, onConfirm, confirmLabel = "Deactivate", busy }) => {
//   if (!open) return null;
//   return (
//     <div className="apt-modal-overlay" onClick={onCancel}>
//       <div className="apt-modal apt-modal--sm" onClick={(e) => e.stopPropagation()}>
//         <div className="apt-modal-header">
//           <h3>{title}</h3>
//           <button className="apt-modal-close" onClick={onCancel}>✕</button>
//         </div>
//         <div className="apt-modal-body">
//           <p className="apt-confirm-text">{message}</p>
//         </div>
//         <div className="apt-modal-footer">
//           <button className="apt-btn-ghost" onClick={onCancel} disabled={busy}>Cancel</button>
//           <button className="apt-btn-danger" onClick={onConfirm} disabled={busy}>
//             {busy ? "Please wait…" : confirmLabel}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// // ──────────────────────────────────────────────────────────────────────────────
// //  DEPARTMENT MODAL (Create / Edit)
// // ──────────────────────────────────────────────────────────────────────────────
// const emptyDepartment = { departmentId: "", name: "", location: "", active: true };

// const DepartmentModal = ({ open, onClose, onSaved, editing, companyId }) => {
//   const [form, setForm] = useState(emptyDepartment);
//   const [saving, setSaving] = useState(false);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     if (open) {
//       setForm(editing ? { ...emptyDepartment, ...editing } : emptyDepartment);
//       setError("");
//     }
//   }, [open, editing]);

//   if (!open) return null;

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setForm((p) => ({ ...p, [name]: type === "checkbox" ? checked : value }));
//   };

//   const handleSubmit = async () => {
//     if (!form.name.trim()) { setError("Department name is required."); return; }
//     setSaving(true);
//     setError("");
//     try {
//       const payload = { ...form, companyId };
//       let res;
//       if (editing) {
//         res = await axios.put(`${API_URL}/api/appointments/departments/${editing.departmentId}`, payload, { headers: authHeader() });
//       } else {
//         // FIX: Remove empty departmentId so MongoDB auto-generates it
//         delete payload.departmentId;
//         res = await axios.post(`${API_URL}/api/appointments/departments`, payload, { headers: authHeader() });
//       }
//       onSaved(res.data?.department ?? payload);
//       onClose();
//     } catch (e) {
//       setError(e.response?.data?.message || "Something went wrong. Please try again.");
//     } finally {
//       setSaving(false);
//     }
//   };

//   return (
//     <div className="apt-modal-overlay" onClick={onClose}>
//       <div className="apt-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="apt-modal-header">
//           <h3>{editing ? "Edit Department" : "New Department"}</h3>
//           <button className="apt-modal-close" onClick={onClose}>✕</button>
//         </div>
//         <div className="apt-modal-body">
//           {error && <div className="apt-form-error">{error}</div>}
//           <div className="apt-form-row">
//             <label className="apt-form-label">Department name<span className="apt-req">*</span></label>
//             <input
//               className="apt-form-input"
//               name="name"
//               value={form.name}
//               onChange={handleChange}
//               placeholder="e.g. Cardiology"
//               autoFocus
//             />
//           </div>
//           <div className="apt-form-row">
//             <label className="apt-form-label">Location</label>
//             <input
//               className="apt-form-input"
//               name="location"
//               value={form.location}
//               onChange={handleChange}
//               placeholder="e.g. Block A, 2nd Floor"
//             />
//           </div>
//           {editing && (
//             <label className="apt-checkbox-row">
//               <input type="checkbox" name="active" checked={!!form.active} onChange={handleChange} />
//               Active
//             </label>
//           )}
//         </div>
//         <div className="apt-modal-footer">
//           <button className="apt-btn-ghost" onClick={onClose} disabled={saving}>Cancel</button>
//           <button className="apt-btn-primary" onClick={handleSubmit} disabled={saving}>
//             {saving ? "Saving…" : editing ? "Save changes" : "Create department"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// // ──────────────────────────────────────────────────────────────────────────────
// //  PERSON MODAL (Create / Edit)
// // ──────────────────────────────────────────────────────────────────────────────
// const emptyPerson = { personId: "", departmentId: "", name: "", position: "", linkedUserId: "", active: true };

// const PersonModal = ({ open, onClose, onSaved, editing, companyId, departments }) => {
//   const [form, setForm] = useState(emptyPerson);
//   const [saving, setSaving] = useState(false);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     if (open) {
//       setForm(editing ? { ...emptyPerson, ...editing } : emptyPerson);
//       setError("");
//     }
//   }, [open, editing]);

//   if (!open) return null;

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setForm((p) => ({ ...p, [name]: type === "checkbox" ? checked : value }));
//   };

//   const handleSubmit = async () => {
//     if (!form.name.trim()) { setError("Person name is required."); return; }
//     if (!form.departmentId) { setError("Please select a department."); return; }
//     setSaving(true);
//     setError("");
//     try {
//       const payload = { ...form, companyId };
//       let res;
//       if (editing) {
//         res = await axios.put(`${API_URL}/api/appointments/persons/${editing.personId}`, payload, { headers: authHeader() });
//       } else {
//         // FIX: Remove empty personId so MongoDB auto-generates it
//         delete payload.personId;
//         res = await axios.post(`${API_URL}/api/appointments/persons`, payload, { headers: authHeader() });
//       }
//       onSaved(res.data?.person ?? payload);
//       onClose();
//     } catch (e) {
//       setError(e.response?.data?.message || "Something went wrong. Please try again.");
//     } finally {
//       setSaving(false);
//     }
//   };

//   return (
//     <div className="apt-modal-overlay" onClick={onClose}>
//       <div className="apt-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="apt-modal-header">
//           <h3>{editing ? "Edit Person" : "New Person"}</h3>
//           <button className="apt-modal-close" onClick={onClose}>✕</button>
//         </div>
//         <div className="apt-modal-body">
//           {error && <div className="apt-form-error">{error}</div>}
//           <div className="apt-form-row">
//             <label className="apt-form-label">Full name<span className="apt-req">*</span></label>
//             <input
//               className="apt-form-input"
//               name="name"
//               value={form.name}
//               onChange={handleChange}
//               placeholder="e.g. Dr. Anita Sharma"
//               autoFocus
//             />
//           </div>
//           <div className="apt-form-grid">
//             <div className="apt-form-row">
//               <label className="apt-form-label">Department<span className="apt-req">*</span></label>
//               <select
//                 className="apt-form-input apt-native-select"
//                 name="departmentId"
//                 value={form.departmentId != null ? String(form.departmentId) : ""}
//                 onChange={handleChange}
//               >
//                 <option value="">Select department</option>
//                 {departments.map((d, i) => {
//                   const id = d.departmentId ?? d.id ?? d._id;
//                   return (
//                     <option key={id ?? i} value={id != null ? String(id) : ""}>
//                       {d.name}
//                     </option>
//                   );
//                 })}
//               </select>
//               {form.departmentId ? (
//                 <div className="apt-selected-tag">
//                   Selected: <strong>
//                     {departments.find((d) => String(d.departmentId ?? d.id ?? d._id) === String(form.departmentId))?.name || form.departmentId}
//                   </strong>
//                 </div>
//               ) : (
//                 <div className="apt-selected-tag apt-selected-tag--muted">No department selected yet</div>
//               )}
//             </div>
//             <div className="apt-form-row">
//               <label className="apt-form-label">Position</label>
//               <input
//                 className="apt-form-input"
//                 name="position"
//                 value={form.position}
//                 onChange={handleChange}
//                 placeholder="e.g. Senior Consultant"
//               />
//             </div>
//           </div>
//           <div className="apt-form-row">
//             <label className="apt-form-label">Linked user ID <span className="apt-optional">(optional)</span></label>
//             <input
//               className="apt-form-input"
//               name="linkedUserId"
//               value={form.linkedUserId}
//               onChange={handleChange}
//               placeholder="Link this person to an existing system user"
//             />
//           </div>
//           {editing && (
//             <label className="apt-checkbox-row">
//               <input type="checkbox" name="active" checked={!!form.active} onChange={handleChange} />
//               Active
//             </label>
//           )}
//         </div>
//         <div className="apt-modal-footer">
//           <button className="apt-btn-ghost" onClick={onClose} disabled={saving}>Cancel</button>
//           <button className="apt-btn-primary" onClick={handleSubmit} disabled={saving}>
//             {saving ? "Saving…" : editing ? "Save changes" : "Create person"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// // ──────────────────────────────────────────────────────────────────────────────
// //  MAIN PAGE
// // ──────────────────────────────────────────────────────────────────────────────
// const Appointment = () => {
//   const { user } = useContext(AuthContext);

//   const stableUser = useMemo(() => ({
//     id: user?.id,
//     accountType: user?.accountType,
//     companyId: user?.companyId,
//   }), [user?.id, user?.accountType, user?.companyId]);

//   const companyId = useMemo(() =>
//     isOwnerLevel(stableUser.accountType) ? stableUser.id : stableUser.companyId,
//     [stableUser]
//   );

//   const [tab, setTab] = useState("departments");
//   const [search, setSearch] = useState("");
//   const [showInactive, setShowInactive] = useState(false);

//   const [departments, setDepartments] = useState([]);
//   const [loadingDepartments, setLoadingDepartments] = useState(false);

//   const [persons, setPersons] = useState([]);
//   const [loadingPersons, setLoadingPersons] = useState(false);
//   const [personDeptFilter, setPersonDeptFilter] = useState("");

//   const [deptModalOpen, setDeptModalOpen] = useState(false);
//   const [editingDept, setEditingDept] = useState(null);

//   const [personModalOpen, setPersonModalOpen] = useState(false);
//   const [editingPerson, setEditingPerson] = useState(null);

//   const [confirmTarget, setConfirmTarget] = useState(null);
//   const [confirmBusy, setConfirmBusy] = useState(false);

//   const [toast, setToast] = useState(null);
//   const showToast = useCallback((message, kind = "success") => {
//     setToast({ message, kind });
//     setTimeout(() => setToast(null), 3000);
//   }, []);

//   // ─── Fetch departments ─────────────────────────────────────────────────────
//   const fetchDepartments = useCallback(() => {
//     if (!companyId) return;
//     setLoadingDepartments(true);
//     axios.get(`${API_URL}/api/appointments/departments/company/${companyId}`, {
//       headers: authHeader(),
//       params: { activeOnly: !showInactive },
//     })
//       .then((r) => setDepartments(Array.isArray(r.data) ? r.data : []))
//       .catch((e) => { console.error(e); showToast("Failed to load departments.", "error"); })
//       .finally(() => setLoadingDepartments(false));
//   }, [companyId, showInactive, showToast]);

//   // ─── Fetch persons ──────────────────────────────────────────────────────────
//   const fetchPersons = useCallback(() => {
//     if (!companyId) return;
//     setLoadingPersons(true);
//     axios.get(`${API_URL}/api/appointments/persons/company/${companyId}`, {
//       headers: authHeader(),
//       params: {
//         activeOnly: !showInactive,
//         ...(personDeptFilter ? { departmentId: personDeptFilter } : {}),
//       },
//     })
//       .then((r) => setPersons(Array.isArray(r.data) ? r.data : []))
//       .catch((e) => { console.error(e); showToast("Failed to load persons.", "error"); })
//       .finally(() => setLoadingPersons(false));
//   }, [companyId, showInactive, personDeptFilter, showToast]);

//   useEffect(() => { fetchDepartments(); }, [fetchDepartments]);
//   useEffect(() => { fetchPersons(); }, [fetchPersons]);

//   const departmentNameById = useMemo(() => {
//     const map = {};
//     departments.forEach((d) => {
//       const id = d.departmentId ?? d.id ?? d._id;
//       if (id != null) map[String(id)] = d.name;
//     });
//     return map;
//   }, [departments]);

//   const filteredDepartments = useMemo(() => {
//     const q = search.trim().toLowerCase();
//     if (!q) return departments;
//     return departments.filter((d) =>
//       d.name?.toLowerCase().includes(q) || d.location?.toLowerCase().includes(q)
//     );
//   }, [departments, search]);

//   const filteredPersons = useMemo(() => {
//     const q = search.trim().toLowerCase();
//     if (!q) return persons;
//     return persons.filter((p) =>
//       p.name?.toLowerCase().includes(q) || p.position?.toLowerCase().includes(q)
//     );
//   }, [persons, search]);

//   const activeDeptCount = departments.filter((d) => d.active).length;
//   const activePersonCount = persons.filter((p) => p.active).length;

//   const handleDeptSaved = (dept) => {
//     showToast(editingDept ? "Department updated." : "Department created.");
//     fetchDepartments();
//   };

//   const handlePersonSaved = () => {
//     showToast(editingPerson ? "Person updated." : "Person created.");
//     fetchPersons();
//   };

//   const openConfirm = (type, item) => {
//     setConfirmTarget({
//       type,
//       id: type === "department" ? item.departmentId : item.personId,
//       name: item.name,
//     });
//   };

//   const handleConfirmDeactivate = async () => {
//     if (!confirmTarget) return;
//     setConfirmBusy(true);
//     try {
//       if (confirmTarget.type === "department") {
//         await axios.delete(`${API_URL}/api/appointments/departments/${confirmTarget.id}`, { headers: authHeader() });
//         showToast("Department deactivated.");
//         fetchDepartments();
//       } else {
//         await axios.delete(`${API_URL}/api/appointments/persons/${confirmTarget.id}`, { headers: authHeader() });
//         showToast("Person deactivated.");
//         fetchPersons();
//       }
//       setConfirmTarget(null);
//     } catch (e) {
//       console.error(e);
//       showToast("Action failed. Please try again.", "error");
//     } finally {
//       setConfirmBusy(false);
//     }
//   };

//   return (
//     <>
//       <style>{APT_CSS}</style>
//       <div className="apt-root">
//         <div className="apt-topbar">
//           <div>
//             <h1 className="apt-page-title">Appointments</h1>
//             <p className="apt-page-sub">Manage departments and persons available for booking</p>
//           </div>
//           <div style={{ display: "flex", gap: 10 }}>
//             <button
//               className="apt-btn-primary"
//               onClick={() => {
//                 if (tab === "departments") { setEditingDept(null); setDeptModalOpen(true); }
//                 else { setEditingPerson(null); setPersonModalOpen(true); }
//               }}
//             >
//               <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ marginRight: 6 }}>
//                 <line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />
//               </svg>
//               {tab === "departments" ? "New Department" : "New Person"}
//             </button>
//           </div>
//         </div>

//         <div className="apt-stats-row">
//           <StatBadge label="Total departments" value={departments.length} icon="🏢" accent="#673AB7" />
//           <StatBadge label="Active departments" value={activeDeptCount} icon="✓" accent="#16a34a" />
//           <StatBadge label="Total persons" value={persons.length} icon="👤" accent="#f59e0b" />
//           <StatBadge label="Active persons" value={activePersonCount} icon="✓" accent="#10b981" />
//         </div>

//         <div className="apt-controls">
//           <div className="apt-tabs">
//             <button
//               className={`apt-tab ${tab === "departments" ? "apt-tab--active" : ""}`}
//               onClick={() => setTab("departments")}
//             >
//               Departments <span className="apt-tab-badge">{departments.length}</span>
//             </button>
//             <button
//               className={`apt-tab ${tab === "persons" ? "apt-tab--active" : ""}`}
//               onClick={() => setTab("persons")}
//             >
//               Persons <span className="apt-tab-badge">{persons.length}</span>
//             </button>
//           </div>

//           <div className="apt-controls-right">
//             {tab === "persons" && (
//               <div className="apt-filter-wrap">
//                 <select
//                   className="apt-select apt-native-select"
//                   value={personDeptFilter}
//                   onChange={(e) => setPersonDeptFilter(e.target.value)}
//                 >
//                   <option value="">All departments</option>
//                   {departments.map((d, i) => {
//                     const id = d.departmentId ?? d.id ?? d._id;
//                     return (
//                       <option key={id ?? i} value={id != null ? String(id) : ""}>
//                         {d.name}
//                       </option>
//                     );
//                   })}
//                 </select>
//                 {personDeptFilter && (
//                   <span className="apt-filter-chip">
//                     {departments.find((d) => String(d.departmentId ?? d.id ?? d._id) === String(personDeptFilter))?.name || personDeptFilter}
//                     <button
//                       type="button"
//                       className="apt-filter-chip-x"
//                       onClick={() => setPersonDeptFilter("")}
//                       aria-label="Clear department filter"
//                     >
//                       ✕
//                     </button>
//                   </span>
//                 )}
//               </div>
//             )}
//             <div className="apt-search-wrap">
//               <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                 <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
//               </svg>
//               <input
//                 className="apt-search-input"
//                 placeholder={tab === "departments" ? "Search departments…" : "Search persons…"}
//                 value={search}
//                 onChange={(e) => setSearch(e.target.value)}
//               />
//             </div>
//             <label className="apt-checkbox-row apt-checkbox-row--inline">
//               <input type="checkbox" checked={showInactive} onChange={(e) => setShowInactive(e.target.checked)} />
//               Show inactive
//             </label>
//           </div>
//         </div>

//         <div className="apt-content">
//           {tab === "departments" ? (
//             loadingDepartments ? (
//               <div className="apt-grid">
//                 {Array(6).fill(0).map((_, i) => <Skeleton key={i} h={92} />)}
//               </div>
//             ) : filteredDepartments.length === 0 ? (
//               <EmptyState message={search ? "No departments match your search." : "No departments yet. Create one to get started."} />
//             ) : (
//               <div className="apt-grid">
//                 {filteredDepartments.map((d) => (
//                   <div key={d.departmentId} className="apt-card">
//                     <div className="apt-card-top">
//                       <Avatar name={d.name || "?"} color="#673AB7" />
//                       <div className="apt-card-body">
//                         <div className="apt-card-name">{d.name}</div>
//                         <div className="apt-card-meta">{d.location || "No location set"}</div>
//                       </div>
//                       <StatusPill active={d.active} />
//                     </div>
//                     <div className="apt-card-actions">
//                       <button className="apt-btn-ghost apt-btn-sm" onClick={() => { setEditingDept(d); setDeptModalOpen(true); }}>
//                         Edit
//                       </button>
//                       {d.active && (
//                         <button className="apt-btn-danger-ghost apt-btn-sm" onClick={() => openConfirm("department", d)}>
//                           Deactivate
//                         </button>
//                       )}
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             )
//           ) : (
//             loadingPersons ? (
//               <div className="apt-grid">
//                 {Array(6).fill(0).map((_, i) => <Skeleton key={i} h={104} />)}
//               </div>
//             ) : filteredPersons.length === 0 ? (
//               <EmptyState message={search ? "No persons match your search." : "No persons yet. Add one to get started."} />
//             ) : (
//               <div className="apt-grid">
//                 {filteredPersons.map((p) => (
//                   <div key={p.personId} className="apt-card">
//                     <div className="apt-card-top">
//                       <Avatar name={p.name || "?"} color="#f59e0b" />
//                       <div className="apt-card-body">
//                         <div className="apt-card-name">{p.name}</div>
//                         <div className="apt-card-meta">{p.position || "No position set"}</div>
//                         <div className="apt-card-dept">
//                           {departmentNameById[String(p.departmentId)] || "Unassigned department"}
//                         </div>
//                       </div>
//                       <StatusPill active={p.active} />
//                     </div>
//                     <div className="apt-card-actions">
//                       <button className="apt-btn-ghost apt-btn-sm" onClick={() => { setEditingPerson(p); setPersonModalOpen(true); }}>
//                         Edit
//                       </button>
//                       {p.active && (
//                         <button className="apt-btn-danger-ghost apt-btn-sm" onClick={() => openConfirm("person", p)}>
//                           Deactivate
//                         </button>
//                       )}
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             )
//           )}
//         </div>

//         <DepartmentModal
//           open={deptModalOpen}
//           onClose={() => setDeptModalOpen(false)}
//           onSaved={handleDeptSaved}
//           editing={editingDept}
//           companyId={companyId}
//         />
//         <PersonModal
//           open={personModalOpen}
//           onClose={() => setPersonModalOpen(false)}
//           onSaved={handlePersonSaved}
//           editing={editingPerson}
//           companyId={companyId}
//           departments={departments}
//         />
//         <ConfirmModal
//           open={!!confirmTarget}
//           title={confirmTarget?.type === "department" ? "Deactivate department?" : "Deactivate person?"}
//           message={`"${confirmTarget?.name}" will be marked inactive. You can reactivate it later by editing the record.`}
//           onCancel={() => setConfirmTarget(null)}
//           onConfirm={handleConfirmDeactivate}
//           busy={confirmBusy}
//         />

//         {toast && (
//           <div className={`apt-toast ${toast.kind === "error" ? "apt-toast--error" : ""}`}>
//             {toast.message}
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// // ──────────────────────────────────────────────────────────────────────────────
// //  CSS — mirrors the CRM theme used across the dashboard
// // ──────────────────────────────────────────────────────────────────────────────
// const APT_CSS = `
//   @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap');

//   .apt-root { font-family: 'Plus Jakarta Sans', sans-serif; background: #EEF2FC; min-height: 100vh; padding: 0 0 40px; color: #1a1f36; }

//   .apt-topbar { background: #fff; border-bottom: 1px solid #e5e9f0; padding: 18px 28px; display: flex; align-items: center; justify-content: space-between; position: sticky; top: 0; z-index: 10; box-shadow: 0 1px 4px rgba(0,0,0,.06); flex-wrap: wrap; gap: 12px; }
//   .apt-page-title { font-size: 20px; font-weight: 700; color: #673AB7; letter-spacing: -0.3px; }
//   .apt-page-sub { font-size: 12px; color: #6b7280; margin-top: 2px; }

//   .apt-stats-row { display: flex; gap: 14px; padding: 20px 28px 0; flex-wrap: wrap; }
//   .apt-stat-card { flex: 1; min-width: 180px; background: #fff; border: 1px solid #e5e9f0; border-radius: 12px; padding: 16px 18px; display: flex; align-items: flex-start; gap: 14px; position: relative; overflow: hidden; transition: box-shadow .2s, transform .2s; }
//   .apt-stat-card:hover { box-shadow: 0 4px 16px rgba(103,58,183,.08); transform: translateY(-1px); }
//   .apt-stat-bar { position: absolute; bottom: 0; left: 0; right: 0; height: 3px; background: var(--accent,#673AB7); opacity: .7; }
//   .apt-stat-icon { font-size: 22px; width: 40px; height: 40px; border-radius: 10px; background: color-mix(in srgb,var(--accent,#673AB7) 12%,transparent); display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
//   .apt-stat-body { flex: 1; min-width: 0; }
//   .apt-stat-val { font-size: 24px; font-weight: 700; color: #1a1f36; line-height: 1; }
//   .apt-stat-label { font-size: 12px; color: #6b7280; margin-top: 4px; font-weight: 500; }

//   .apt-controls { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px; padding: 20px 28px 0; }
//   .apt-tabs { display: flex; background: #fff; border: 1px solid #e5e9f0; border-radius: 10px; padding: 4px; gap: 2px; }
//   .apt-tab { padding: 8px 16px; font-size: 13px; font-weight: 600; color: #6b7280; background: none; border: none; border-radius: 7px; cursor: pointer; display: flex; align-items: center; gap: 6px; transition: background .15s, color .15s; font-family: inherit; }
//   .apt-tab:hover { color: #1a1f36; }
//   .apt-tab--active { color: #fff; background: #673AB7; }
//   .apt-tab-badge { background: rgba(0,0,0,.08); font-size: 10px; padding: 1px 6px; border-radius: 10px; font-weight: 600; }
//   .apt-tab--active .apt-tab-badge { background: rgba(255,255,255,.25); }

//   .apt-controls-right { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
//   .apt-select { background: #fff; border: 1px solid #e5e9f0; border-radius: 8px; padding: 8px 12px; font-size: 12px; color: #1a1f36; font-family: inherit; cursor: pointer; outline: none; min-width: 150px; }
//   .apt-select:hover, .apt-select:focus { border-color: #673AB7; }

//   select.apt-native-select {
//     appearance: none !important;
//     -webkit-appearance: none !important;
//     -moz-appearance: none !important;
//     color: #1a1f36 !important;
//     background-color: #fff !important;
//     background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%236b7280'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E") !important;
//     background-repeat: no-repeat !important;
//     background-position: right 10px center !important;
//     background-size: 14px !important;
//     padding-right: 32px !important;
//     cursor: pointer;
//   }
  
//   select.apt-native-select::-ms-expand { display: none; }

//   .apt-selected-tag { font-size: 11.5px; color: #673AB7; font-weight: 600; margin-top: 2px; }
//   .apt-selected-tag--muted { color: #9ca3af; font-weight: 500; }

//   .apt-filter-wrap { display: flex; align-items: center; gap: 8px; }
//   .apt-filter-chip { display: inline-flex; align-items: center; gap: 6px; background: #f3e8ff; color: #673AB7; font-size: 11px; font-weight: 600; padding: 4px 6px 4px 10px; border-radius: 20px; white-space: nowrap; }
//   .apt-filter-chip-x { background: none; border: none; color: #673AB7; cursor: pointer; font-size: 10px; width: 16px; height: 16px; display: flex; align-items: center; justify-content: center; border-radius: 50%; padding: 0; }
//   .apt-filter-chip-x:hover { background: rgba(103,58,183,.15); }

//   .apt-search-wrap { display: flex; align-items: center; gap: 8px; background: #fff; border: 1px solid #e5e9f0; border-radius: 8px; padding: 8px 12px; min-width: 220px; color: #9ca3af; }
//   .apt-search-wrap:focus-within { border-color: #673AB7; }
//   .apt-search-input { border: none; outline: none; font-size: 12px; font-family: inherit; flex: 1; color: #1a1f36; background: transparent; }

//   .apt-checkbox-row { display: flex; align-items: center; gap: 8px; font-size: 12px; font-weight: 500; color: #4b5563; cursor: pointer; user-select: none; }
//   .apt-checkbox-row--inline { background: #fff; border: 1px solid #e5e9f0; border-radius: 8px; padding: 8px 12px; }
//   .apt-checkbox-row input { accent-color: #673AB7; width: 14px; height: 14px; cursor: pointer; }

//   .apt-content { padding: 18px 28px 0; }
//   .apt-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: 14px; }

//   .apt-card { background: #fff; border: 1px solid #e5e9f0; border-radius: 14px; padding: 16px; box-shadow: 0 1px 3px rgba(0,0,0,.04); transition: box-shadow .2s; display: flex; flex-direction: column; gap: 12px; }
//   .apt-card:hover { box-shadow: 0 4px 14px rgba(0,0,0,.07); }
//   .apt-card-top { display: flex; align-items: flex-start; gap: 12px; }
//   .apt-card-body { flex: 1; min-width: 0; }
//   .apt-card-name { font-size: 14px; font-weight: 700; color: #1a1f36; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
//   .apt-card-meta { font-size: 12px; color: #6b7280; margin-top: 2px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
//   .apt-card-dept { font-size: 11px; color: #673AB7; font-weight: 600; margin-top: 4px; background: #f3e8ff; display: inline-block; padding: 2px 8px; border-radius: 20px; }
//   .apt-card-actions { display: flex; gap: 8px; border-top: 1px solid #f1f5f9; padding-top: 12px; }

//   .apt-avatar { width: 40px; height: 40px; border-radius: 10px; display: flex; align-items: center; justify-content: center; font-size: 12px; font-weight: 700; flex-shrink: 0; letter-spacing: .05em; }
//   .apt-pill { font-size: 10px; font-weight: 700; padding: 3px 9px; border-radius: 20px; white-space: nowrap; flex-shrink: 0; text-transform: uppercase; letter-spacing: .03em; }

//   .apt-btn-primary { background: #673AB7; color: #fff; border: none; border-radius: 8px; padding: 9px 16px; font-size: 13px; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 6px; font-family: inherit; transition: opacity .15s, transform .1s; }
//   .apt-btn-primary:hover { opacity: .9; transform: translateY(-1px); }
//   .apt-btn-primary:disabled { opacity: .6; cursor: not-allowed; transform: none; }

//   .apt-btn-ghost { background: #f8fafc; color: #4b5563; border: 1px solid #e5e9f0; border-radius: 8px; padding: 8px 14px; font-size: 12px; font-weight: 600; cursor: pointer; font-family: inherit; transition: background .1s, border-color .1s; }
//   .apt-btn-ghost:hover { background: #f1f5f9; border-color: #d1d5db; }

//   .apt-btn-danger-ghost { background: #fef2f2; color: #dc2626; border: 1px solid #fecaca; border-radius: 8px; padding: 8px 14px; font-size: 12px; font-weight: 600; cursor: pointer; font-family: inherit; transition: background .1s; }
//   .apt-btn-danger-ghost:hover { background: #fee2e2; }

//   .apt-btn-danger { background: #dc2626; color: #fff; border: none; border-radius: 8px; padding: 9px 16px; font-size: 13px; font-weight: 600; cursor: pointer; font-family: inherit; }
//   .apt-btn-danger:hover { opacity: .9; }
//   .apt-btn-danger:disabled, .apt-btn-ghost:disabled { opacity: .6; cursor: not-allowed; }

//   .apt-btn-sm { flex: 1; padding: 7px 10px; font-size: 11.5px; text-align: center; }

//   .apt-modal-overlay { position: fixed; inset: 0; background: rgba(0,0,0,.45); display: flex; align-items: center; justify-content: center; z-index: 1000; padding: 16px; backdrop-filter: blur(3px); }
//   .apt-modal { background: #fff; border-radius: 16px; width: 100%; max-width: 480px; max-height: 90vh; display: flex; flex-direction: column; overflow: hidden; box-shadow: 0 20px 60px rgba(0,0,0,.2); }
//   .apt-modal--sm { max-width: 400px; }

//   .apt-modal-header { padding: 18px 20px 14px; background-color: #673AB7; border-bottom: 1px solid #f1f5f9; display: flex; align-items: center; justify-content: space-between; }
//   .apt-modal-header h3 { font-size: 16px; font-weight: 700; color: #fff; margin: 0; }
//   .apt-modal-close { background: transparent; color: #fff; border: none; font-size: 16px; cursor: pointer; width: 28px; height: 28px; display: flex; align-items: center; justify-content: center; }

//   .apt-modal-body { padding: 18px 20px; display: flex; flex-direction: column; gap: 14px; overflow-y: auto; }
//   .apt-modal-footer { padding: 14px 20px; border-top: 1px solid #f1f5f9; display: flex; gap: 8px; justify-content: flex-end; }

//   .apt-form-row { display: flex; flex-direction: column; gap: 5px; }
//   .apt-form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }
//   .apt-form-label { font-size: 12px; font-weight: 600; color: #4b5563; }
//   .apt-req { color: #dc2626; margin-left: 2px; }
//   .apt-optional { color: #9ca3af; font-weight: 400; text-transform: none; }
//   .apt-form-input { background: #f8fafc; border: 1px solid #e5e9f0; border-radius: 8px; padding: 9px 12px; font-size: 13px; color: #1a1f36; font-family: inherit; outline: none; width: 100%; transition: border-color .15s; }
//   .apt-form-input:focus { border-color: #673AB7; background: #fff; }
//   .apt-form-error { background: #fef2f2; color: #dc2626; font-size: 12px; font-weight: 500; padding: 10px 12px; border-radius: 8px; border: 1px solid #fecaca; }

//   .apt-confirm-text { font-size: 13px; color: #4b5563; line-height: 1.5; margin: 0; }

//   .apt-empty { display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 50px 20px; color: #d1d5db; gap: 10px; text-align: center; grid-column: 1 / -1; }
//   .apt-empty p { font-size: 12px; color: #9ca3af; font-weight: 500; margin: 0; }

//   .apt-skeleton { background: linear-gradient(90deg,#f1f5f9 25%,#e9eef5 50%,#f1f5f9 75%); background-size: 200% 100%; animation: apt-shimmer 1.4s infinite; border-radius: 14px; }
//   @keyframes apt-shimmer { 0%{background-position:200% 0} 100%{background-position:-200% 0} }

//   .apt-toast { position: fixed; bottom: 24px; right: 24px; background: #1a1f36; color: #fff; padding: 12px 18px; border-radius: 10px; font-size: 13px; font-weight: 500; box-shadow: 0 8px 24px rgba(0,0,0,.2); z-index: 2000; animation: apt-toast-in .2s ease; }
//   .apt-toast--error { background: #dc2626; }
//   @keyframes apt-toast-in { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }

//   @media (max-width: 640px) {
//     .apt-form-grid { grid-template-columns: 1fr; }
//     .apt-controls-right { width: 100%; }
//     .apt-search-wrap { flex: 1; }
//   }
// `;

// export default Appointment;






import { useState, useEffect, useContext, useCallback, useMemo } from "react";
import { AuthContext } from "../context/AuthContext";
import axios from "axios";
import { API_URL } from "../../Constants";

// ─── Role helpers (same convention as Dashboard) ────────────────────────────
const ROLE = {
  COMPANY: "COMPANY",
  VICE_PRESIDENT: "VICE_PRESIDENT",
  MANAGER: "MANAGER",
  TEAM_LEAD: "TEAM_LEAD",
  EXECUTIVE: "EXECUTIVE",
  HR: "HR",
  SUPER_SUPER_ADMIN: "SUPER_SUPER_ADMIN",
  SUPER_ADMIN: "SUPER_ADMIN",
  RESELLER: "RESELLER",
};
const isOwnerLevel = (t) =>
  [ROLE.COMPANY, ROLE.SUPER_SUPER_ADMIN, ROLE.SUPER_ADMIN, ROLE.RESELLER].includes(t);

// ─── Token helper ────────────────────────────────────────────────────────────
const authHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

// ─── Small shared UI bits (mirrors Dashboard's visual language) ─────────────
const Avatar = ({ name = "", color = "#673AB7" }) => {
  const parts = name.trim().split(" ");
  const initials = parts.length >= 2
    ? parts[0][0] + parts[parts.length - 1][0]
    : (parts[0]?.[0] ?? "?");
  return (
    <div className="apt-avatar" style={{ background: color + "22", color }}>
      {initials.toUpperCase()}
    </div>
  );
};

const StatusPill = ({ active }) => (
  <span
    className="apt-pill"
    style={{
      background: active ? "#dcfce7" : "#fee2e2",
      color: active ? "#16a34a" : "#dc2626",
    }}
  >
    {active ? "Active" : "Inactive"}
  </span>
);

const StatBadge = ({ label, value, icon, accent = "#673AB7" }) => (
  <div className="apt-stat-card" style={{ "--accent": accent }}>
    <div className="apt-stat-icon">{icon}</div>
    <div className="apt-stat-body">
      <div className="apt-stat-val">{value ?? "—"}</div>
      <div className="apt-stat-label">{label}</div>
    </div>
    <div className="apt-stat-bar" />
  </div>
);

const EmptyState = ({ message = "No data available" }) => (
  <div className="apt-empty">
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2">
      <path d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
    </svg>
    <p>{message}</p>
  </div>
);

const Skeleton = ({ h = 60 }) => (
  <div className="apt-skeleton" style={{ height: h }} />
);

const ConfirmModal = ({ open, title, message, onCancel, onConfirm, confirmLabel = "Deactivate", busy }) => {
  if (!open) return null;
  return (
    <div className="apt-modal-overlay" onClick={onCancel}>
      <div className="apt-modal apt-modal--sm" onClick={(e) => e.stopPropagation()}>
        <div className="apt-modal-header">
          <h3>{title}</h3>
          <button className="apt-modal-close" onClick={onCancel}>✕</button>
        </div>
        <div className="apt-modal-body">
          <p className="apt-confirm-text">{message}</p>
        </div>
        <div className="apt-modal-footer">
          <button className="apt-btn-ghost" onClick={onCancel} disabled={busy}>Cancel</button>
          <button className="apt-btn-danger" onClick={onConfirm} disabled={busy}>
            {busy ? "Please wait…" : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

// ──────────────────────────────────────────────────────────────────────────────
//  DEPARTMENT MODAL (Create / Edit)
// ──────────────────────────────────────────────────────────────────────────────
const emptyDepartment = { departmentId: "", name: "", location: "", active: true };

const DepartmentModal = ({ open, onClose, onSaved, editing, companyId }) => {
  const [form, setForm] = useState(emptyDepartment);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (open) {
      setForm(editing ? { ...emptyDepartment, ...editing } : emptyDepartment);
      setError("");
    }
  }, [open, editing]);

  if (!open) return null;

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((p) => ({ ...p, [name]: type === "checkbox" ? checked : value }));
  };

  const handleSubmit = async () => {
    if (!form.name.trim()) { setError("Department name is required."); return; }
    setSaving(true);
    setError("");
    try {
      const payload = { ...form, companyId };
      let res;
      if (editing) {
        res = await axios.put(`${API_URL}/api/appointments/departments/${editing.departmentId}`, payload, { headers: authHeader() });
      } else {
        // FIX: Remove empty departmentId so MongoDB auto-generates it
        delete payload.departmentId;
        res = await axios.post(`${API_URL}/api/appointments/departments`, payload, { headers: authHeader() });
      }
      onSaved(res.data?.department ?? payload);
      onClose();
    } catch (e) {
      setError(e.response?.data?.message || "Something went wrong. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="apt-modal-overlay" onClick={onClose}>
      <div className="apt-modal" onClick={(e) => e.stopPropagation()}>
        <div className="apt-modal-header">
          <h3>{editing ? "Edit Department" : "New Department"}</h3>
          <button className="apt-modal-close" onClick={onClose}>✕</button>
        </div>
        <div className="apt-modal-body">
          {error && <div className="apt-form-error">{error}</div>}
          <div className="apt-form-row">
            <label className="apt-form-label">Department name<span className="apt-req">*</span></label>
            <input
              className="apt-form-input"
              name="name"
              value={form.name}
              onChange={handleChange}
              placeholder="e.g. Cardiology"
              autoFocus
            />
          </div>
          <div className="apt-form-row">
            <label className="apt-form-label">Location</label>
            <input
              className="apt-form-input"
              name="location"
              value={form.location}
              onChange={handleChange}
              placeholder="e.g. Block A, 2nd Floor"
            />
          </div>
          {editing && (
            <label className="apt-checkbox-row">
              <input type="checkbox" name="active" checked={!!form.active} onChange={handleChange} />
              Active
            </label>
          )}
        </div>
        <div className="apt-modal-footer">
          <button className="apt-btn-ghost" onClick={onClose} disabled={saving}>Cancel</button>
          <button className="apt-btn-primary" onClick={handleSubmit} disabled={saving}>
            {saving ? "Saving…" : editing ? "Save changes" : "Create department"}
          </button>
        </div>
      </div>
    </div>
  );
};

// ──────────────────────────────────────────────────────────────────────────────
//  PERSON MODAL (Create / Edit)
// ──────────────────────────────────────────────────────────────────────────────
const emptyPerson = { personId: "", departmentId: "", name: "", position: "", linkedUserId: "", active: true };

const PersonModal = ({ open, onClose, onSaved, editing, companyId, departments }) => {
  const [form, setForm] = useState(emptyPerson);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (open) {
      setForm(editing ? { ...emptyPerson, ...editing } : emptyPerson);
      setError("");
    }
  }, [open, editing]);

  if (!open) return null;

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((p) => ({ ...p, [name]: type === "checkbox" ? checked : value }));
  };

  const handleSubmit = async () => {
    if (!form.name.trim()) { setError("Person name is required."); return; }
    if (!form.departmentId) { setError("Please select a department."); return; }
    setSaving(true);
    setError("");
    try {
      const payload = { ...form, companyId };
      let res;
      if (editing) {
        res = await axios.put(`${API_URL}/api/appointments/persons/${editing.personId}`, payload, { headers: authHeader() });
      } else {
        // FIX: Remove empty personId so MongoDB auto-generates it
        delete payload.personId;
        res = await axios.post(`${API_URL}/api/appointments/persons`, payload, { headers: authHeader() });
      }
      onSaved(res.data?.person ?? payload);
      onClose();
    } catch (e) {
      setError(e.response?.data?.message || "Something went wrong. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="apt-modal-overlay" onClick={onClose}>
      <div className="apt-modal" onClick={(e) => e.stopPropagation()}>
        <div className="apt-modal-header">
          <h3>{editing ? "Edit Person" : "New Person"}</h3>
          <button className="apt-modal-close" onClick={onClose}>✕</button>
        </div>
        <div className="apt-modal-body">
          {error && <div className="apt-form-error">{error}</div>}
          <div className="apt-form-row">
            <label className="apt-form-label">Full name<span className="apt-req">*</span></label>
            <input
              className="apt-form-input"
              name="name"
              value={form.name}
              onChange={handleChange}
              placeholder="e.g. Dr. Anita Sharma"
              autoFocus
            />
          </div>
          <div className="apt-form-grid">
            <div className="apt-form-row">
              <label className="apt-form-label">Department<span className="apt-req">*</span></label>
              <select
                className="apt-form-input apt-native-select"
                name="departmentId"
                value={form.departmentId != null ? String(form.departmentId) : ""}
                onChange={handleChange}
              >
                <option value="">Select department</option>
                {departments.map((d, i) => {
                  const id = d.departmentId ?? d.id ?? d._id;
                  return (
                    <option key={id ?? i} value={id != null ? String(id) : ""}>
                      {d.name}
                    </option>
                  );
                })}
              </select>
              {form.departmentId ? (
                <div className="apt-selected-tag">
                  Selected: <strong>
                    {departments.find((d) => String(d.departmentId ?? d.id ?? d._id) === String(form.departmentId))?.name || form.departmentId}
                  </strong>
                </div>
              ) : (
                <div className="apt-selected-tag apt-selected-tag--muted">No department selected yet</div>
              )}
            </div>
            <div className="apt-form-row">
              <label className="apt-form-label">Position</label>
              <input
                className="apt-form-input"
                name="position"
                value={form.position}
                onChange={handleChange}
                placeholder="e.g. Senior Consultant"
              />
            </div>
          </div>
          <div className="apt-form-row">
            <label className="apt-form-label">Linked user ID <span className="apt-optional">(optional)</span></label>
            <input
              className="apt-form-input"
              name="linkedUserId"
              value={form.linkedUserId}
              onChange={handleChange}
              placeholder="Link this person to an existing system user"
            />
          </div>
          {editing && (
            <label className="apt-checkbox-row">
              <input type="checkbox" name="active" checked={!!form.active} onChange={handleChange} />
              Active
            </label>
          )}
        </div>
        <div className="apt-modal-footer">
          <button className="apt-btn-ghost" onClick={onClose} disabled={saving}>Cancel</button>
          <button className="apt-btn-primary" onClick={handleSubmit} disabled={saving}>
            {saving ? "Saving…" : editing ? "Save changes" : "Create person"}
          </button>
        </div>
      </div>
    </div>
  );
};

// ──────────────────────────────────────────────────────────────────────────────
//  MAIN PAGE
// ──────────────────────────────────────────────────────────────────────────────
const Appointment = () => {
  const { user } = useContext(AuthContext);

  const stableUser = useMemo(() => ({
    id: user?.id,
    accountType: user?.accountType,
    companyId: user?.companyId,
  }), [user?.id, user?.accountType, user?.companyId]);

  const companyId = useMemo(() =>
    isOwnerLevel(stableUser.accountType) ? stableUser.id : stableUser.companyId,
    [stableUser]
  );

  const [tab, setTab] = useState("departments");
  const [search, setSearch] = useState("");
  const [showInactive, setShowInactive] = useState(false);

  const [departments, setDepartments] = useState([]);
  const [loadingDepartments, setLoadingDepartments] = useState(false);

  const [persons, setPersons] = useState([]);
  const [loadingPersons, setLoadingPersons] = useState(false);
  const [personDeptFilter, setPersonDeptFilter] = useState("");

  const [deptModalOpen, setDeptModalOpen] = useState(false);
  const [editingDept, setEditingDept] = useState(null);

  const [personModalOpen, setPersonModalOpen] = useState(false);
  const [editingPerson, setEditingPerson] = useState(null);

  const [confirmTarget, setConfirmTarget] = useState(null);
  const [confirmBusy, setConfirmBusy] = useState(false);

  const [toast, setToast] = useState(null);
  const showToast = useCallback((message, kind = "success") => {
    setToast({ message, kind });
    setTimeout(() => setToast(null), 3000);
  }, []);

  // ─── Fetch departments ─────────────────────────────────────────────────────
  const fetchDepartments = useCallback(() => {
    if (!companyId) return;
    setLoadingDepartments(true);
    axios.get(`${API_URL}/api/appointments/departments/company/${companyId}`, {
      headers: authHeader(),
      params: { activeOnly: !showInactive },
    })
      .then((r) => setDepartments(Array.isArray(r.data) ? r.data : []))
      .catch((e) => { console.error(e); showToast("Failed to load departments.", "error"); })
      .finally(() => setLoadingDepartments(false));
  }, [companyId, showInactive, showToast]);

  // ─── Fetch persons ──────────────────────────────────────────────────────────
  const fetchPersons = useCallback(() => {
    if (!companyId) return;
    setLoadingPersons(true);
    axios.get(`${API_URL}/api/appointments/persons/company/${companyId}`, {
      headers: authHeader(),
      params: {
        activeOnly: !showInactive,
        ...(personDeptFilter ? { departmentId: personDeptFilter } : {}),
      },
    })
      .then((r) => setPersons(Array.isArray(r.data) ? r.data : []))
      .catch((e) => { console.error(e); showToast("Failed to load persons.", "error"); })
      .finally(() => setLoadingPersons(false));
  }, [companyId, showInactive, personDeptFilter, showToast]);

  useEffect(() => { fetchDepartments(); }, [fetchDepartments]);
  useEffect(() => { fetchPersons(); }, [fetchPersons]);

  const departmentNameById = useMemo(() => {
    const map = {};
    departments.forEach((d) => {
      const id = d.departmentId ?? d.id ?? d._id;
      if (id != null) map[String(id)] = d.name;
    });
    return map;
  }, [departments]);

  const filteredDepartments = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return departments;
    return departments.filter((d) =>
      d.name?.toLowerCase().includes(q) || d.location?.toLowerCase().includes(q)
    );
  }, [departments, search]);

  const filteredPersons = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return persons;
    return persons.filter((p) =>
      p.name?.toLowerCase().includes(q) || p.position?.toLowerCase().includes(q)
    );
  }, [persons, search]);

  const activeDeptCount = departments.filter((d) => d.active).length;
  const activePersonCount = persons.filter((p) => p.active).length;

  const handleDeptSaved = (dept) => {
    showToast(editingDept ? "Department updated." : "Department created.");
    fetchDepartments();
  };

  const handlePersonSaved = () => {
    showToast(editingPerson ? "Person updated." : "Person created.");
    fetchPersons();
  };

  const openConfirm = (type, item) => {
    setConfirmTarget({
      type,
      id: type === "department" ? item.departmentId : item.personId,
      name: item.name,
    });
  };

  const handleConfirmDeactivate = async () => {
    if (!confirmTarget) return;
    setConfirmBusy(true);
    try {
      if (confirmTarget.type === "department") {
        await axios.delete(`${API_URL}/api/appointments/departments/${confirmTarget.id}`, { headers: authHeader() });
        showToast("Department deactivated.");
        fetchDepartments();
      } else {
        await axios.delete(`${API_URL}/api/appointments/persons/${confirmTarget.id}`, { headers: authHeader() });
        showToast("Person deactivated.");
        fetchPersons();
      }
      setConfirmTarget(null);
    } catch (e) {
      console.error(e);
      showToast("Action failed. Please try again.", "error");
    } finally {
      setConfirmBusy(false);
    }
  };

  return (
    <>
      <style>{APT_CSS}</style>
      <div className="apt-root">
        <div className="apt-topbar">
          <div>
            <h1 className="apt-page-title">Appointments</h1>
            <p className="apt-page-sub">Manage departments and persons available for booking</p>
          </div>
          <div style={{ display: "flex", gap: 10 }}>
            <button
              className="apt-btn-primary"
              onClick={() => {
                if (tab === "departments") { setEditingDept(null); setDeptModalOpen(true); }
                else { setEditingPerson(null); setPersonModalOpen(true); }
              }}
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ marginRight: 6 }}>
                <line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />
              </svg>
              {tab === "departments" ? "New Department" : "New Person"}
            </button>
          </div>
        </div>

        <div className="apt-stats-row">
          <StatBadge label="Total departments" value={departments.length} icon="🏢" accent="#673AB7" />
          <StatBadge label="Active departments" value={activeDeptCount} icon="✓" accent="#16a34a" />
          <StatBadge label="Total persons" value={persons.length} icon="👤" accent="#f59e0b" />
          <StatBadge label="Active persons" value={activePersonCount} icon="✓" accent="#10b981" />
        </div>

        <div className="apt-controls">
          <div className="apt-tabs">
            <button
              className={`apt-tab ${tab === "departments" ? "apt-tab--active" : ""}`}
              onClick={() => setTab("departments")}
            >
              Departments <span className="apt-tab-badge">{departments.length}</span>
            </button>
            <button
              className={`apt-tab ${tab === "persons" ? "apt-tab--active" : ""}`}
              onClick={() => setTab("persons")}
            >
              Persons <span className="apt-tab-badge">{persons.length}</span>
            </button>
          </div>

          <div className="apt-controls-right">
            {tab === "persons" && (
              <div className="apt-filter-wrap">
                <select
                  className="apt-select apt-native-select"
                  value={personDeptFilter}
                  onChange={(e) => setPersonDeptFilter(e.target.value)}
                >
                  <option value="">All departments</option>
                  {departments.map((d, i) => {
                    const id = d.departmentId ?? d.id ?? d._id;
                    return (
                      <option key={id ?? i} value={id != null ? String(id) : ""}>
                        {d.name}
                      </option>
                    );
                  })}
                </select>
                {personDeptFilter && (
                  <span className="apt-filter-chip">
                    {departments.find((d) => String(d.departmentId ?? d.id ?? d._id) === String(personDeptFilter))?.name || personDeptFilter}
                    <button
                      type="button"
                      className="apt-filter-chip-x"
                      onClick={() => setPersonDeptFilter("")}
                      aria-label="Clear department filter"
                    >
                      ✕
                    </button>
                  </span>
                )}
              </div>
            )}
            <div className="apt-search-wrap">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
              </svg>
              <input
                className="apt-search-input"
                placeholder={tab === "departments" ? "Search departments…" : "Search persons…"}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            <label className="apt-checkbox-row apt-checkbox-row--inline">
              <input type="checkbox" checked={showInactive} onChange={(e) => setShowInactive(e.target.checked)} />
              Show inactive
            </label>
          </div>
        </div>

        <div className="apt-content">
          {tab === "departments" ? (
            loadingDepartments ? (
              <div className="apt-grid">
                {Array(6).fill(0).map((_, i) => <Skeleton key={i} h={92} />)}
              </div>
            ) : filteredDepartments.length === 0 ? (
              <EmptyState message={search ? "No departments match your search." : "No departments yet. Create one to get started."} />
            ) : (
              <div className="apt-grid">
                {filteredDepartments.map((d) => (
                  <div key={d.departmentId} className="apt-card">
                    <div className="apt-card-top">
                      <Avatar name={d.name || "?"} color="#673AB7" />
                      <div className="apt-card-body">
                        <div className="apt-card-name">{d.name}</div>
                        <div className="apt-card-meta">{d.location || "No location set"}</div>
                      </div>
                      <StatusPill active={d.active} />
                    </div>
                    <div className="apt-card-actions">
                      <button className="apt-btn-ghost apt-btn-sm" onClick={() => { setEditingDept(d); setDeptModalOpen(true); }}>
                        Edit
                      </button>
                      {d.active && (
                        <button className="apt-btn-danger-ghost apt-btn-sm" onClick={() => openConfirm("department", d)}>
                          Deactivate
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )
          ) : (
            loadingPersons ? (
              <div className="apt-grid">
                {Array(6).fill(0).map((_, i) => <Skeleton key={i} h={104} />)}
              </div>
            ) : filteredPersons.length === 0 ? (
              <EmptyState message={search ? "No persons match your search." : "No persons yet. Add one to get started."} />
            ) : (
              <div className="apt-grid">
                {filteredPersons.map((p) => (
                  <div key={p.personId} className="apt-card">
                    <div className="apt-card-top">
                      <Avatar name={p.name || "?"} color="#f59e0b" />
                      <div className="apt-card-body">
                        <div className="apt-card-name">{p.name}</div>
                        <div className="apt-card-meta">{p.position || "No position set"}</div>
                        <div className="apt-card-dept">
                          {departmentNameById[String(p.departmentId)] || "Unassigned department"}
                        </div>
                      </div>
                      <StatusPill active={p.active} />
                    </div>
                    <div className="apt-card-actions">
                      <button className="apt-btn-ghost apt-btn-sm" onClick={() => { setEditingPerson(p); setPersonModalOpen(true); }}>
                        Edit
                      </button>
                      {p.active && (
                        <button className="apt-btn-danger-ghost apt-btn-sm" onClick={() => openConfirm("person", p)}>
                          Deactivate
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )
          )}
        </div>

        <DepartmentModal
          open={deptModalOpen}
          onClose={() => setDeptModalOpen(false)}
          onSaved={handleDeptSaved}
          editing={editingDept}
          companyId={companyId}
        />
        <PersonModal
          open={personModalOpen}
          onClose={() => setPersonModalOpen(false)}
          onSaved={handlePersonSaved}
          editing={editingPerson}
          companyId={companyId}
          departments={departments}
        />
        <ConfirmModal
          open={!!confirmTarget}
          title={confirmTarget?.type === "department" ? "Deactivate department?" : "Deactivate person?"}
          message={`"${confirmTarget?.name}" will be marked inactive. You can reactivate it later by editing the record.`}
          onCancel={() => setConfirmTarget(null)}
          onConfirm={handleConfirmDeactivate}
          busy={confirmBusy}
        />

        {toast && (
          <div className={`apt-toast ${toast.kind === "error" ? "apt-toast--error" : ""}`}>
            {toast.message}
          </div>
        )}
      </div>
    </>
  );
};

// ──────────────────────────────────────────────────────────────────────────────
//  CSS — mirrors the CRM theme used across the dashboard
// ──────────────────────────────────────────────────────────────────────────────
const APT_CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Sora:wght@600;700&family=Inter:wght@400;500;600;700&display=swap');

  .apt-root { font-family: 'Inter', sans-serif; background: #FAF8FF; min-height: 100vh; padding: 0 0 40px; color: #1a1f36; }
  .apt-page-title, .apt-modal-header h3 { font-family: 'Sora', sans-serif; }

  .apt-topbar { background: #fff; border-bottom: 1px solid #e5e9f0; padding: 18px 28px; display: flex; align-items: center; justify-content: space-between; position: sticky; top: 0; z-index: 10; box-shadow: 0 1px 4px rgba(0,0,0,.06); flex-wrap: wrap; gap: 12px; }
  .apt-page-title { font-size: 20px; font-weight: 700; color: #673AB7; letter-spacing: -0.3px; }
  .apt-page-sub { font-size: 12px; color: #6b7280; margin-top: 2px; }

  .apt-stats-row { display: flex; gap: 14px; padding: 20px 28px 0; flex-wrap: wrap; }
  .apt-stat-card { flex: 1; min-width: 180px; background: #fff; border: 1px solid #e5e9f0; border-radius: 12px; padding: 16px 18px; display: flex; align-items: flex-start; gap: 14px; position: relative; overflow: hidden; transition: box-shadow .2s, transform .2s; }
  .apt-stat-card:hover { box-shadow: 0 4px 16px rgba(103,58,183,.08); transform: translateY(-1px); }
  .apt-stat-bar { position: absolute; bottom: 0; left: 0; right: 0; height: 3px; background: var(--accent,#673AB7); opacity: .7; }
  .apt-stat-icon { font-size: 22px; width: 40px; height: 40px; border-radius: 10px; background: color-mix(in srgb,var(--accent,#673AB7) 12%,transparent); display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
  .apt-stat-body { flex: 1; min-width: 0; }
  .apt-stat-val { font-size: 24px; font-weight: 700; color: #1a1f36; line-height: 1; }
  .apt-stat-label { font-size: 12px; color: #6b7280; margin-top: 4px; font-weight: 500; }

  .apt-controls { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px; padding: 20px 28px 0; }
  .apt-tabs { display: flex; background: #fff; border: 1px solid #e5e9f0; border-radius: 10px; padding: 4px; gap: 2px; }
  .apt-tab { padding: 8px 16px; font-size: 13px; font-weight: 600; color: #6b7280; background: none; border: none; border-radius: 7px; cursor: pointer; display: flex; align-items: center; gap: 6px; transition: background .15s, color .15s; font-family: inherit; }
  .apt-tab:hover { color: #1a1f36; }
  .apt-tab--active { color: #fff; background: #673AB7; }
  .apt-tab-badge { background: rgba(0,0,0,.08); font-size: 10px; padding: 1px 6px; border-radius: 10px; font-weight: 600; }
  .apt-tab--active .apt-tab-badge { background: rgba(255,255,255,.25); }

  .apt-controls-right { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
  .apt-select { background: #fff; border: 1px solid #e5e9f0; border-radius: 8px; padding: 8px 12px; font-size: 12px; color: #1a1f36; font-family: inherit; cursor: pointer; outline: none; min-width: 150px; }
  .apt-select:hover, .apt-select:focus { border-color: #673AB7; }

  select.apt-native-select {
    appearance: none !important;
    -webkit-appearance: none !important;
    -moz-appearance: none !important;
    color: #1a1f36 !important;
    background-color: #fff !important;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%236b7280'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E") !important;
    background-repeat: no-repeat !important;
    background-position: right 10px center !important;
    background-size: 14px !important;
    padding-right: 32px !important;
    cursor: pointer;
  }
  
  select.apt-native-select::-ms-expand { display: none; }

  .apt-selected-tag { font-size: 11.5px; color: #673AB7; font-weight: 600; margin-top: 2px; }
  .apt-selected-tag--muted { color: #9ca3af; font-weight: 500; }

  .apt-filter-wrap { display: flex; align-items: center; gap: 8px; }
  .apt-filter-chip { display: inline-flex; align-items: center; gap: 6px; background: #f3e8ff; color: #673AB7; font-size: 11px; font-weight: 600; padding: 4px 6px 4px 10px; border-radius: 20px; white-space: nowrap; }
  .apt-filter-chip-x { background: none; border: none; color: #673AB7; cursor: pointer; font-size: 10px; width: 16px; height: 16px; display: flex; align-items: center; justify-content: center; border-radius: 50%; padding: 0; }
  .apt-filter-chip-x:hover { background: rgba(103,58,183,.15); }

  .apt-search-wrap { display: flex; align-items: center; gap: 8px; background: #fff; border: 1px solid #e5e9f0; border-radius: 8px; padding: 8px 12px; min-width: 220px; color: #9ca3af; }
  .apt-search-wrap:focus-within { border-color: #673AB7; }
  .apt-search-input { border: none; outline: none; font-size: 12px; font-family: inherit; flex: 1; color: #1a1f36; background: transparent; }

  .apt-checkbox-row { display: flex; align-items: center; gap: 8px; font-size: 12px; font-weight: 500; color: #4b5563; cursor: pointer; user-select: none; }
  .apt-checkbox-row--inline { background: #fff; border: 1px solid #e5e9f0; border-radius: 8px; padding: 8px 12px; }
  .apt-checkbox-row input { accent-color: #673AB7; width: 14px; height: 14px; cursor: pointer; }

  .apt-content { padding: 18px 28px 0; }
  .apt-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: 14px; }

  .apt-card { background: #fff; border: 1px solid #e5e9f0; border-radius: 14px; padding: 16px; box-shadow: 0 1px 3px rgba(0,0,0,.04); transition: box-shadow .2s; display: flex; flex-direction: column; gap: 12px; }
  .apt-card:hover { box-shadow: 0 4px 14px rgba(0,0,0,.07); }
  .apt-card-top { display: flex; align-items: flex-start; gap: 12px; }
  .apt-card-body { flex: 1; min-width: 0; }
  .apt-card-name { font-size: 14px; font-weight: 700; color: #1a1f36; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .apt-card-meta { font-size: 12px; color: #6b7280; margin-top: 2px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .apt-card-dept { font-size: 11px; color: #673AB7; font-weight: 600; margin-top: 4px; background: #f3e8ff; display: inline-block; padding: 2px 8px; border-radius: 20px; }
  .apt-card-actions { display: flex; gap: 8px; border-top: 1px solid #f1f5f9; padding-top: 12px; }

  .apt-avatar { width: 40px; height: 40px; border-radius: 10px; display: flex; align-items: center; justify-content: center; font-size: 12px; font-weight: 700; flex-shrink: 0; letter-spacing: .05em; }
  .apt-pill { font-size: 10px; font-weight: 700; padding: 3px 9px; border-radius: 20px; white-space: nowrap; flex-shrink: 0; text-transform: uppercase; letter-spacing: .03em; }

  .apt-btn-primary { background: #673AB7; color: #fff; border: none; border-radius: 8px; padding: 9px 16px; font-size: 13px; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 6px; font-family: inherit; transition: opacity .15s, transform .1s; }
  .apt-btn-primary:hover { opacity: .9; transform: translateY(-1px); }
  .apt-btn-primary:disabled { opacity: .6; cursor: not-allowed; transform: none; }

  .apt-btn-ghost { background: #f8fafc; color: #4b5563; border: 1px solid #e5e9f0; border-radius: 8px; padding: 8px 14px; font-size: 12px; font-weight: 600; cursor: pointer; font-family: inherit; transition: background .1s, border-color .1s; }
  .apt-btn-ghost:hover { background: #f1f5f9; border-color: #d1d5db; }

  .apt-btn-danger-ghost { background: #fef2f2; color: #dc2626; border: 1px solid #fecaca; border-radius: 8px; padding: 8px 14px; font-size: 12px; font-weight: 600; cursor: pointer; font-family: inherit; transition: background .1s; }
  .apt-btn-danger-ghost:hover { background: #fee2e2; }

  .apt-btn-danger { background: #dc2626; color: #fff; border: none; border-radius: 8px; padding: 9px 16px; font-size: 13px; font-weight: 600; cursor: pointer; font-family: inherit; }
  .apt-btn-danger:hover { opacity: .9; }
  .apt-btn-danger:disabled, .apt-btn-ghost:disabled { opacity: .6; cursor: not-allowed; }

  .apt-btn-sm { flex: 1; padding: 7px 10px; font-size: 11.5px; text-align: center; }

  .apt-modal-overlay { position: fixed; inset: 0; background: rgba(0,0,0,.45); display: flex; align-items: center; justify-content: center; z-index: 1000; padding: 16px; backdrop-filter: blur(3px); }
  .apt-modal { background: #fff; border-radius: 16px; width: 100%; max-width: 480px; max-height: 90vh; display: flex; flex-direction: column; overflow: hidden; box-shadow: 0 20px 60px rgba(0,0,0,.2); }
  .apt-modal--sm { max-width: 400px; }

  .apt-modal-header { padding: 18px 20px 14px; background-color: #673AB7; border-bottom: 1px solid #f1f5f9; display: flex; align-items: center; justify-content: space-between; }
  .apt-modal-header h3 { font-size: 16px; font-weight: 700; color: #fff; margin: 0; }
  .apt-modal-close { background: transparent; color: #fff; border: none; font-size: 16px; cursor: pointer; width: 28px; height: 28px; display: flex; align-items: center; justify-content: center; }

  .apt-modal-body { padding: 18px 20px; display: flex; flex-direction: column; gap: 14px; overflow-y: auto; }
  .apt-modal-footer { padding: 14px 20px; border-top: 1px solid #f1f5f9; display: flex; gap: 8px; justify-content: flex-end; }

  .apt-form-row { display: flex; flex-direction: column; gap: 5px; }
  .apt-form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }
  .apt-form-label { font-size: 12px; font-weight: 600; color: #4b5563; }
  .apt-req { color: #dc2626; margin-left: 2px; }
  .apt-optional { color: #9ca3af; font-weight: 400; text-transform: none; }
  .apt-form-input { background: #f8fafc; border: 1px solid #e5e9f0; border-radius: 8px; padding: 9px 12px; font-size: 13px; color: #1a1f36; font-family: inherit; outline: none; width: 100%; transition: border-color .15s; }
  .apt-form-input:focus { border-color: #673AB7; background: #fff; }
  .apt-form-error { background: #fef2f2; color: #dc2626; font-size: 12px; font-weight: 500; padding: 10px 12px; border-radius: 8px; border: 1px solid #fecaca; }

  .apt-confirm-text { font-size: 13px; color: #4b5563; line-height: 1.5; margin: 0; }

  .apt-empty { display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 50px 20px; color: #d1d5db; gap: 10px; text-align: center; grid-column: 1 / -1; }
  .apt-empty p { font-size: 12px; color: #9ca3af; font-weight: 500; margin: 0; }

  .apt-skeleton { background: linear-gradient(90deg,#f1f5f9 25%,#e9eef5 50%,#f1f5f9 75%); background-size: 200% 100%; animation: apt-shimmer 1.4s infinite; border-radius: 14px; }
  @keyframes apt-shimmer { 0%{background-position:200% 0} 100%{background-position:-200% 0} }

  .apt-toast { position: fixed; bottom: 24px; right: 24px; background: #1a1f36; color: #fff; padding: 12px 18px; border-radius: 10px; font-size: 13px; font-weight: 500; box-shadow: 0 8px 24px rgba(0,0,0,.2); z-index: 2000; animation: apt-toast-in .2s ease; }
  .apt-toast--error { background: #dc2626; }
  @keyframes apt-toast-in { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }

  @media (max-width: 640px) {
    .apt-form-grid { grid-template-columns: 1fr; }
    .apt-controls-right { width: 100%; }
    .apt-search-wrap { flex: 1; }
  }
`;

export default Appointment;